export default __webpack_public_path__ + "static/media/pogo.c3ac66db.svg";